
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ProductCategoryFilter from "./ProductCategoryFilter";

type ProductCategory = 'all' | 'ostomy' | 'medicine' | 'other';

interface ProductsHeaderProps {
  selectedCategory: ProductCategory;
  onCategoryChange: (category: ProductCategory) => void;
}

const ProductsHeader = ({ selectedCategory, onCategoryChange }: ProductsHeaderProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
      <h1 className="page-title">Products</h1>
      <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
        <ProductCategoryFilter 
          selectedCategory={selectedCategory} 
          onCategoryChange={onCategoryChange} 
        />
        <Button 
          className="bg-blue-500 hover:bg-blue-600"
          onClick={() => navigate("/products/add")}
        >
          <PlusCircle className="mr-2 h-4 w-4" />
          Add Product
        </Button>
      </div>
    </div>
  );
};

export default ProductsHeader;
